




















import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_updatePensionUnitSelection } from '@/queries/__generated__/updatePensionUnitSelection';
import { GET_PENSION_UNIT_SELECTION } from '@/queries/PensionUnitSelection';
import PensionUnitSelectionForm from '@/components/PensionUnitSelection/PensionUnitSelectionForm.vue';
import { GQL_pensionUnitSelection_pensionUnitSelection } from '@/queries/__generated__/pensionUnitSelection';
import gql from 'graphql-tag';

const UPDATE_PENSION_UNIT_SELECTION = gql`
  mutation updatePensionUnitSelection($pensionUnitSelection: PensionUnitSelectionUpdate!) {
    updatePensionUnitSelection(
      input: { pensionUnitSelection: $pensionUnitSelection }
    ) {
      pensionUnitSelection {
        id
        pensionUnit {
          id
          name
        }
        validFrom
        validTo

        isSentToAltinn
        minimalValidTo
      }
    }
  },
`;

@Component({
  components: {
    PensionUnitSelectionForm,
  },
})
export default class PensionUnitSelectionEdit extends Vue {
  @Prop([ String ]) private id!: string;

  private UPDATE_PENSION_UNIT_SELECTION = UPDATE_PENSION_UNIT_SELECTION;
  private GET_PENSION_UNIT_SELECTION = GET_PENSION_UNIT_SELECTION;

  private formatData(data: GQL_pensionUnitSelection_pensionUnitSelection) {
    return {
      id: data.id,
      pensionUnitId: data.pensionUnit.id,
      pensionUnit: data.pensionUnit, // For keep-alive-item
      validFrom: data.validFrom,
      validTo: data.validTo,
      isSentToAltinn: data.isSentToAltinn,
      minimalValidTo: data.minimalValidTo,
    };
  }

  @Emit()
  private pensionUnitSelectionUpdated(store: InMemoryCache, query: { data: GQL_updatePensionUnitSelection }) {
    return query.data.updatePensionUnitSelection && query.data.updatePensionUnitSelection.pensionUnitSelection;
  }
}
